/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  IClRegionData,
  IClRegionDataState,
  IClRegionOptionList,
} from "../../Interfaces/SiteContent";

/**
 * Cl Regions data selector.
 */
export const getClRegions = (state: IClRegionDataState): IClRegionData[] => state.clRegions;

/**
 * CL Regions option list data selector.
 */
export const getClRegionsOptionList = (state: IClRegionDataState): IClRegionOptionList[] =>
  state.clRegionsOptionList;

/**
 * CL Regions data load error selector.
 */
export const getClRegionsLoadError = (state: IClRegionDataState): string =>
  state.clRegionsLoadError;

/**
 * Geo data selector.
 */
export const getGeoData = (state: IClRegionDataState): IClRegionData[] => state.geoData;

/**
 * Geo data load error selector.
 */
export const getGeoDataLoadError = (state: IClRegionDataState): string => state.geoDataLoadError;
